export default function DownloadArchivedReportDirective() {
  return {
    restrict: 'E',
    template: require('./download-archived-report.directive.html'),
    scope: {
      reportInstanceArchiveId: '@',
      tooltip: '@',
      tooltipAppendToSelector: '@',
      iconType: '@',
      iconSizeClass: '@',
      iconColorClass: '@',
    },
    controller: 'DownloadArchivedReportDirectiveController',
    controllerAs: 'downloadArchivedReportVM',
    bindToController: true,
    replace: true,
  };
}
